import React, { useEffect, useMemo, useState } from "react";
import { Dropdown, Table } from "antd";
import {
  AiOutlineMore,
  AiOutlineFilePdf,
  AiOutlineFileText,
  AiOutlineCloseCircle,
  AiOutlineSend,
  AiOutlineInfoCircle,
  AiOutlineMobile,
} from "react-icons/ai";
import * as S from "../style";
import { usePermissions } from "../../../../../../Context/permissionContext";
import {
  INSURANCE_CANCEL_PUSH_LABEL,
  resolveInsuranceCancelActionVisibility,
} from "../../../../../../helpers/getInsuranceCancelActionVisibility";
import { TActiveInsurances, TInsurance } from "./types";
import { getInsuranceColumns } from "./constants";

export const ActiveInsurances: React.FC<TActiveInsurances> = ({
  insurances,
  printTicketInsurance,
  handleModalAdhesionAgreement,
  showCancelConfirmationModal,
  handleClickSendEmail,
  openDetailModal,
  onRequestCancelViaApp,
}) => {
  const [totalInsurance, setTotalInsurance] = useState<number>(0);
  const { permissions } = usePermissions();
  const { showSacCancelAction, showPushCancelAction } = useMemo(
    () => resolveInsuranceCancelActionVisibility(permissions),
    [permissions]
  );

  const getMenu = (insurance: TInsurance) => {
    const menuItems = [];

    if (insurance.possuiBilhete) {
      menuItems.push(
        <S.StyledMenuItem
          key="emitirBilhete"
          onClick={() => printTicketInsurance(insurance)}
        >
          <AiOutlineFilePdf size={20} /> Emitir bilhete
        </S.StyledMenuItem>
      );
    }

    if (insurance.possuiTermoAdesao) {
      menuItems.push(
        <S.StyledMenuItem
          key="emitirTermo"
          onClick={() => handleModalAdhesionAgreement(insurance)}
        >
          <AiOutlineFileText size={20} /> Emitir termo de adesão
        </S.StyledMenuItem>
      );
    }

    if (showPushCancelAction) {
      menuItems.push(
        <S.StyledMenuItem
          key="cancelarViaApp"
          onClick={onRequestCancelViaApp}
          data-testid="menu_link_cancelamento_seguro_app"
        >
          <AiOutlineMobile size={20} /> {INSURANCE_CANCEL_PUSH_LABEL}
        </S.StyledMenuItem>
      );
    }

    if (showSacCancelAction) {
      menuItems.push(
        <S.StyledMenuItem
          key="cancelar"
          onClick={() => showCancelConfirmationModal(insurance)}
        >
          <AiOutlineCloseCircle size={20} /> Cancelar
        </S.StyledMenuItem>
      );
    }

    menuItems.push(
      <S.StyledMenuItem
        key="enviar"
        onClick={() => handleClickSendEmail(insurance)}
      >
        <AiOutlineSend size={20} /> Enviar
      </S.StyledMenuItem>
    );

    menuItems.push(
      <S.StyledMenuItem
        key="informacoes"
        onClick={() => openDetailModal(insurance)}
      >
        <AiOutlineInfoCircle size={20} /> Informações
      </S.StyledMenuItem>
    );

    return <S.StyledMenu>{menuItems}</S.StyledMenu>;
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const renderActions = (record: any) => {
    return (
      <S.InsuranceActions>
        <Dropdown
          overlay={getMenu(record.originalData)}
          trigger={["click"]}
          placement="bottomRight"
        >
          <AiOutlineMore className="custom-icon" />
        </Dropdown>
      </S.InsuranceActions>
    );
  };
  const activeInsurancesColumns = getInsuranceColumns(renderActions, "A");

  const tableData = insurances.map((insurance: TInsurance) => {
    return {
      key: insurance.codigoAdesao,
      codigo: insurance.codigoAdesaoDependente || insurance.codigoAdesao,
      descricao: insurance.descricaoSeguro,
      valor: parseFloat(insurance.valorParcela.replace("R$", "")),
      originalData: insurance,
    };
  });

  useEffect(() => {
    const calculateTotalInsurance = () => {
      let totalSum = 0;
      insurances.forEach((seguro) => {
        const valorParcela = parseFloat(
          seguro.valorParcela.replace("R$ ", "").replace(",", ".")
        );
        totalSum += valorParcela;
      });
      setTotalInsurance(totalSum);
    };
    calculateTotalInsurance();
  }, [insurances]);
  return (
    <div>
      <Table
        columns={activeInsurancesColumns}
        dataSource={tableData}
        rowKey="key"
        scroll={{ y: 200 }}
        pagination={{ pageSize: 3, showSizeChanger: false }}
      />

      {insurances.length > 0 && (
        <S.TotalInsuranceInfo>
          <p>Total</p>
          <h2>R$ {totalInsurance.toFixed(2)}</h2>
        </S.TotalInsuranceInfo>
      )}
    </div>
  );
};
